window.addEventListener('load', () => {
  document.addEventListener('click', (event) => {
    const singleBtn = event.target.closest('.button.show-this-price');
    if (singleBtn) {
      const priceEl = singleBtn.closest('.price__container')?.querySelector('.invisible-price-container');
      if (priceEl) priceEl.classList.add('show');
      return;
    }

    const globalBtn = event.target.closest('#show-all-prices');
    if (globalBtn) {
      document.querySelectorAll('.invisible-price-container').forEach((el) => {
        el.classList.add('show');
      });
    }
  });

  const target = document.querySelector('.product__info-wrapper.grid__item.scroll-trigger.animate--slide-in');
  if (!target) return;

  const handleProductInfoChange = () => {
    console.log('variant HTML replaced/updated');

    // run any logic needed after Shopify swaps markup
    // example:
    // document.querySelectorAll('.invisible-price-container').forEach((el) => {
    //   el.classList.remove('show');
    // });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
        handleProductInfoChange();
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
});